module.exports = __webpack_public_path__ + "static/media/julesMapVuitton.83407694.png";